// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1peRr","row":"ProcedureTreatmentSummary_row__2t4Uu"};